import axios from 'axios';
import '../services/GlobalVariables';

export const DEFAULT_POS_ORDER_TYPE_SETTINGS = {
  enableDineIn: true,
  enableTakeaway: true,
  enableDelivery: true,
  enableFoodpanda: true,
};

const API_URL = `${global.SET_API_URL}posOrderTypeSettings`;

const normalizeSettings = (settings = {}) => ({
  enableDineIn: settings.enableDineIn !== false,
  enableTakeaway: settings.enableTakeaway !== false,
  enableDelivery: settings.enableDelivery !== false,
  enableFoodpanda: settings.enableFoodpanda !== false,
});

export const fetchPosOrderTypeSettings = async () => {
  const response = await axios.get(API_URL);
  return normalizeSettings(response.data?.data || DEFAULT_POS_ORDER_TYPE_SETTINGS);
};

export const savePosOrderTypeSettings = async (settings) => {
  const response = await axios.post(API_URL, normalizeSettings(settings));
  return normalizeSettings(response.data?.data || settings);
};
